import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faPlay, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardName from "../../../components/global/CardName";
import { listClear as clearWidget } from "../../../reducers/models/widgetData";
import TabLog from "../../../components/card/TabLog";
import SrvButton from "../../../components/global/SrvButton";
import Widget from "../../../components/card/widget/Widget";
import WidgetModalAdd from "../../../components/card/widget/WidgetAddModal";
import WidgetAddFavorite from "../../../components/card/widget/WidgetAddFavorite";
import axios from "axios";
import CardUserOne from "../../../components/card/CardUserOne";
import TabBarCard from "../../../components/ui/TabBarCard";
import ButtonAction from "../../../components/global/ButtonAction";
import CardProjectChange from "../../../components/card/project/CardProject";
import WidgetItem from "../../../components/card/widget/WidgetItem";
import WidgetItemLabel from "../../../components/card/widget/WidgetItemLabel";
import WidgetItemPriority from "../../../components/card/widget/WidgetItemPriority";
import WidgetItemDeadlines from "../../../components/card/widget/WidgetItemDeadlines";
import ErrorAdd from "../../../util/ErrorAdd";

function TaskModal({ show, onHide, id_board, id_project, model, id_type_appointment, board_id_type }) {
  const id_object = 3;

  const dispatch = useDispatch();

  const refHeader = useRef(null); //Шапка карточки
  const refFooter = useRef(null); //Footer карточки
  const [hightBody, setHightBody] = useState(0);

  const stateSize = useSelector((state) => state.size); //Размеры окна
  const stateWidgetData = useSelector((state) => state.widgetData); //Данные для виджета
  const stateSetting = useSelector((state) => state.setting);//Настройки
  //const stateBoardTaskList = useSelector((state) => state.boardTaskList);

  //TAB START
  const tab = [
    { id_tab: 0, name: "Основное", icon: faPlay, showCount: false },
    { id_tab: 1, name: "История", icon: faArchive, showCount: false },
  ];
  const [tabSelected, setTabSelected] = useState(0);

  function tabHandler(id_tab) {
    setTabSelected(id_tab);

    if (id_tab === 1) {
      axios
        .get("/api/board/taskLogList", { params: { ID_Board_Task: model.ID } })
        .then((res) => {
          if (res.data.Status === 1) {
            setDataLog(res.data.Data);
          } else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          setLog("Неизвестная ошибка!");
          ErrorAdd(err, window.location.href);
        });
    }
  }
  //TAB END

  const [log, setLog] = useState(null);
  const [logWidget, setLogWidget] = useState(null);
  const [loading, setLoading] = useState(false);
  const [widgetModalShow, setWidgetModalShow] = useState(false);
  const [widgetEditing, setWidgetEditing] = useState(false);
  const [archiveModalShow, setArchiveModalShow] = useState(false);

  const [dataLog, setDataLog] = useState([]);

  useEffect(() => {
    /* if (refHeader.current !== undefined & refFooter.current !== undefined & stateSize.desktop !== true) {
       setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - refFooter.current.offsetHeight - 70)
     }
     if (refHeader.current !== undefined & stateSize.desktop === true) {
       setHightBody(stateSize.windowHeight - refHeader.current.offsetHeight - 100)
     }*/
  }, [refHeader, refFooter, stateSize, stateWidgetData, model]);



  //Архивирует задачу
  function taskArchive() {
    axios
      .post("/api_tracker/board/taskArchive", { ID_Board_Task: model.ID })
      .then((res) => {
        if (res.data.Status === 1) {
          setArchiveModalShow(false);
          onHide();
        }
        else {
          setLog(res.data.Error);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLog("Неизвестная ошибка!");
        setLoading(false);
        ErrorAdd(err, window.location.href);
      });
  }

  /********************************START ПРОЕКТ***********************************/
  const [logProject, setLogProject] = useState(null);
  const [loadingProject, setLoadingProject] = useState(null);
  const [hideModalProject, setHideModalProject] = useState(false);

  function updateProjectHandler(id) {
    setLogProject(null);
    setLoadingProject(true);
    setHideModalProject(false);

    axios
      .post("/api_tracker/board/taskUpdateProject", { ID: model.ID, ID_Project: id })
      .then((res) => {
        if (res.data.Status === 1) {
          //setFormIdProject(id);
          setHideModalProject(true);
          setLoadingProject(false);
        }
        else {
          setLogProject(res.data.Error);
          setLoadingProject(false);
        }
      })
      .catch((err) => {
        setLogProject("Неизвестная ошибка!");
        setLoadingProject(false);
        ErrorAdd(err, window.location.href);
      });
  }
  /*********************************END ПРОЕКТ************************************/
  /********************************START WIDGET***********************************/

  const [addedWidget, setAddedWidjet] = useState(null);
  function widgetAddHandler(idWidget) {
    setAddedWidjet(idWidget);
  }
  function widgetMenuHandler(id_menu) {
    //id_menu: 1-Добавление; 2-Редактирование
    if (id_menu === 1) {
      setWidgetModalShow(true);
    }
    if (id_menu === 2) {
      setWidgetEditing(!widgetEditing);
    }
  }
  /*********************************END WIDGET************************************/

  //Событие при  закрытии модального окна
  function eventModalClose() {
    //ОЧИЩАЕМ ФОРМУ
    //dispatch(loadDeadlines({ data: { date_start: null, date_complete: null } }));
    setLog(null);
    setLogWidget(null);
    // setFormIdProject(id_project);

    dispatch(clearWidget()); //Очищаем виджеты

    onHide();
  }

  const [hideName, setHideName] = useState(false);
  const [logName, setLogName] = useState(null);
  const [loadingName, setLoadingName] = useState(false);
  function updateName(val) {
    setLoadingName(true);
    setLogName(null);

    axios.post('/api_tracker/board/taskUpdateName', { ID: model.ID, Name: val })
      .then((resResp) => {
        if (resResp.data.Status !== 1) {
          setLogName(resResp.data.Error);
          setLoadingName(false);

        }
        else {
          setLoadingName(false);
          setHideName(true);
        }
      })
      .catch((err) => {
        setLogName('Неизвестная ошибка!');
        setLoadingName(false);
        ErrorAdd(err, window.location.href);
      });
  }

  return (
    <>
      {show === true && (
        <>
          {widgetModalShow === true && <WidgetModalAdd id={model.ID} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} />}
          {archiveModalShow === true && (
            <Modal show={archiveModalShow} onHide={() => setArchiveModalShow(false)}>
              <Modal.Body>
                <div className="modal_close" onClick={() => setArchiveModalShow(false)}>
                  <FontAwesomeIcon icon={faXmark} className="opacity-50" />
                </div>
                <div className="modal_title text-center mb-15">Архивация задачи</div>
                <div className="fs-5 text-center">Подтвердите архивирование задачи.</div>
                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                <div className="row mt-15">
                  <div className="col-md-12 text-center">
                    <SrvButton typeBtn="archive" textBtn="Архивировать" size="lg" onClick={() => taskArchive()} loading={loading} />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}
          {stateSize.desktop === true ? (
            <Modal show={show} onHide={() => eventModalClose()} size="lg">
              <Modal.Body>
                <div className="mb-5" style={{ display: "flex" }}>
                  <div>
                    <TabBarCard tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} />
                  </div>
                  <div style={{ marginLeft: "auto" }} className="modal_close" onClick={() => eventModalClose()}>
                    <FontAwesomeIcon icon={faXmark} className="opacity-50" />
                  </div>
                </div>
                <div className={tabSelected === 0 ? "d-block" : "d-none"} role="tabpanel">
                  <div className="row">
                    <div className="col-md-8">
                      <div ref={refHeader}>
                        <div>
                          <CardName name={model.Name} updateHandler={updateName} onlyRead={model.ID_Status === 2 ? true : false} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <CardProjectChange idTask={model.ID} idProject={id_project} idObject={id_object} idSelected={model.ID_Project} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={model.ID_Status === 2 ? true : false} />
                          </div>
                          <div style={{ marginLeft: 'auto' }}>
                            {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                              <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={model.ID} onlyRead={false} />
                            )}
                          </div>
                        </div>
                        <div className="mt-5">
                          <div>
                            {stateWidgetData.listStandart.filter(a => a.ID_Widget === 1).length > 0 && (
                              <WidgetItemDeadlines idObject={id_object} idWidget={1} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 1)[0].Number} idItem={model.ID} onlyRead={false} added={addedWidget} />)}
                          </div>
                        </div>
                        <div className="mt-5">
                          <div>{stateWidgetData.list.filter((a) => a.ID_Widget === 1).length > 0 && <WidgetItem idWidget={1} moving={false} idObject={id_object} /*idTab={idTab}*/ idTask={model.ID} number={stateWidgetData.list.filter((a) => a.ID_Widget === 1)[0].Number} editMode={widgetEditing} onlyRead={model.ID_Status === 2 ? true : false} addedWidget={addedWidget} />}</div>
                        </div>
                        {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                          <WidgetItemLabel idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={model.ID} onlyRead={false} added={addedWidget} />)}
                      </div>
                      <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: hightBody - 20, overflow: 'auto' }}>
                        <Widget idObject={id_object} idItem={model.ID} editMode={widgetEditing} idProject={model.ID_Project} onlyRead={model.ID_Project === 2 ? true : false} addedWidget={addedWidget} />
                      </div>
                    </div>
                    <div className="col-md-4" style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 120, overflow: "auto" }}>
                      <>
                        {board_id_type === 3 && (
                          <>
                            <div className="card-block-title">Действия</div>
                            <div>
                              <ButtonAction typeBtn="archive" textBtn="В архив" onClick={() => setArchiveModalShow(true)} />
                            </div>
                          </>
                        )}
                        {id_type_appointment !== 2 && (
                          <>
                            <div className="card-block-title">Ответственный</div>
                            <CardUserOne idItem={model.ID} idUserSelected={model.ID_Responsible} idObject={id_object} data={{ ID_Project: id_project, ID_Board: id_board }} viewed={model.Viewed} />
                          </>
                        )}
                        <WidgetAddFavorite id={model.ID} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} menuChangeHandler={widgetMenuHandler} />
                      </>
                    </div>
                  </div>
                </div>
                <div className={tabSelected === 1 ? "d-block" : "d-none"} role="tabpanel">
                  <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 130, overflow: 'auto' }}>
                    <TabLog data={dataLog} />
                  </div>
                </div>
                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
              </Modal.Body>
            </Modal>
          ) : (
            <Modal show={show} onHide={() => eventModalClose()} size="lg">
              <Modal.Body>
                <div className="mb-5" style={{ display: "flex" }}>
                  <div>
                    <TabBarCard tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} />
                  </div>
                  <div style={{ marginLeft: "auto" }} className="modal_close" onClick={() => eventModalClose()}>
                    <FontAwesomeIcon icon={faXmark} className="opacity-50" />
                  </div>
                </div>
                <div className={tabSelected === 0 ? "d-block" : "d-none"} role="tabpanel">
                  <div ref={refHeader}>
                    <div>
                      <CardName name={model.Name} xxx={model} updateHandler={updateName} onlyRead={model.ID_Status === 2 ? true : false} hide={hideName} setHide={setHideName} log={logName} loading={loadingName} />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>
                        <CardProjectChange idTask={model.ID} idProject={id_project} idObject={id_object} idSelected={model.ID_Project} update={updateProjectHandler} loading={loadingProject} log={logProject} hideModal={hideModalProject} onlyRead={model.ID_Status === 2 ? true : false} />
                      </div>
                      <div style={{ marginLeft: 'auto' }}>
                        {stateWidgetData.listStandart.filter(a => a.ID_Widget === 2).length > 0 && (
                          <WidgetItemPriority idObject={id_object} idWidget={2} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 2)[0].Number} idItem={model.ID} onlyRead={false} />
                        )}
                      </div>
                    </div>
                    <div className="mt-5">
                      <div>
                        {stateWidgetData.listStandart.filter(a => a.ID_Widget === 1).length > 0 && (
                          <WidgetItemDeadlines idObject={id_object} idWidget={1} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 1)[0].Number} idItem={model.ID} onlyRead={false} added={addedWidget} />)}
                      </div>
                    </div>
                    <div className="mt-5">
                      <div>{stateWidgetData.list.filter((a) => a.ID_Widget === 1).length > 0 && <WidgetItem idWidget={1} moving={false} idObject={id_object} /*idTab={idTab}*/ idTask={model.ID} number={stateWidgetData.list.filter((a) => a.ID_Widget === 1)[0].Number} editMode={widgetEditing} onlyRead={model.ID_Status === 2 ? true : false} addedWidget={addedWidget} />}</div>
                    </div>
                    {stateWidgetData.listStandart.filter(a => a.ID_Widget === 3).length > 0 && (
                      <WidgetItemLabel idObject={id_object} idWidget={3} number={stateWidgetData.listStandart.filter(a => a.ID_Widget === 3)[0].Number} idItem={model.ID} onlyRead={false} added={addedWidget} />)}
                  </div>
                  <div key={hightBody} style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: hightBody, overflow: 'auto' }}>
                    <Widget idObject={id_object} idItem={model.ID} editMode={widgetEditing} idProject={model.ID_Project} onlyRead={model.ID_Project === 2 ? true : false} addedWidget={addedWidget} />
                  </div>
                  <div ref={refFooter}>
                    {id_type_appointment !== 2 && (
                      <>
                        <hr></hr>
                        <CardUserOne idItem={model.ID} idUserSelected={model.ID_Responsible} idObject={id_object} data={{ ID_Project: id_project, ID_Board: id_board }} viewed={model.Viewed} />
                      </>
                    )}
                    <hr></hr>
                    <div style={{ height: '55px' }}>
                      {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                      <div className="m_btn_block_footer">
                        {board_id_type === 3 && (
                          <ButtonAction typeBtn="archive" textBtn="В архив" onClick={() => setArchiveModalShow(true)} />
                        )}
                        <WidgetAddFavorite id={model.ID} idObject={id_object} widgetModalShow={widgetModalShow} setWidgetModalShow={() => setWidgetModalShow(false)} addHandler={widgetAddHandler} menuChangeHandler={widgetMenuHandler} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={tabSelected === 1 ? "d-block" : "d-none"} role="tabpanel">
                  <div style={{ minHeight: stateSize.windowHeight / 2.5, maxHeight: stateSize.windowHeight - 90, overflow: 'auto' }}>
                    <TabLog data={dataLog} />
                  </div>
                </div>
                {log !== null && <div className="form_error text-center mt-15">{log}</div>}
              </Modal.Body>
            </Modal>
          )}
        </>
      )}
    </>
  );
}
export default TaskModal;
